module.exports = __webpack_public_path__ + "static/media/cmob18.78db2406.svg";